import { createFileRoute } from '@tanstack/react-router'

import { PortalDeliverablePage } from '@/components/portal/portal-deliverable'

export const Route = createFileRoute('/portal/projets/$projectId_/livrables/$key')({
  component: PortalDeliverableRoute,
})

function PortalDeliverableRoute() {
  const { projectId, key } = Route.useParams()
  return <PortalDeliverablePage key={key} projectId={projectId} deliverableKey={key} />
}
